import { useCallback, useSyncExternalStore } from 'react';

/**
 * Whether a CSS media query currently matches, kept live as it changes.
 *
 * For layouts that must MOUNT one branch per breakpoint rather than hide the
 * other with CSS: a hidden branch still runs its effects, polls and tracking.
 * `LessonLearningLayout` is the case that needed it — its CSS-hidden mobile
 * viewer kept a "text" study-time row open for the whole visit.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query]
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  );
}
